module.exports = __webpack_public_path__ + "static/media/pin.237d7a4c.svg";